import { connect } from 'react-redux';
import { appActions } from '../actions/appAction';
import { FileUploadAPIParam, viewerActions } from '../actions/viewerAction';

import { Viewer } from '../components/Viewer';

export interface ViewerActions {
    setLoading: (loading: boolean) => void;
    comitUploadFileAsync: (param: FileUploadAPIParam) => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setLoading: (loading: boolean) => dispatch(appActions.setLoading(loading)),
        comitUploadFileAsync: (param: FileUploadAPIParam) => dispatch(viewerActions.comitUploadFileAsync(param)),
    }
}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({}, state.viewerState, state.appState);
};

export default connect(mapStateToProps, mapDispatchToProps)(Viewer);
